<div>
    <div echarts [options]="this.defaultOptions" class="echarts" [style]="{height: this.chartHeight() + 'px'}"
        (chartClick)="onChartCellClick($event)" (chartInit)="onChartInit($event)">
    </div>
    <div>
        <div class="legend-grid">
            <div class="legend-slot">
                <span class="legend-color vrij"></span><span>{{'Vrij' | translate: 'Vrij'}}</span>
            </div>
            <div class="legend-slot">
                <span class="legend-color benoemed">1</span><span>{{'Benoemd' | translate: 'Benoemd'}}</span>
            </div>
            <div class="legend-slot">
                <span class="legend-color dubbel-benoemd">2</span><span>{{'Dubbel benoemd' | translate: 'Dubbel benoemd'}}</span>
            </div>
            <div class="legend-slot">
                <span class="legend-color selected"></span><span>{{'Geselecteerd' | translate: 'Geselecteerd'}}</span>
            </div>
            <div class="legend-slot">
                <span class="legend-color out-of-range"></span><span>{{'Out of range' | translate: 'Out of range'}}</span>
            </div>
            <div class="legend-slot">
                <span class="legend-color out-of-range-benoemd">1</span><span>{{'Out of range - benoemd' | translate: 'Out of range - benoemd'}}</span>
            </div>
            <div class="legend-slot">
                <span class="legend-color out-of-range-dbl-benoemd">2</span><span>{{'Out of range - Dubbel benoemd' | translate: 'Out of range - Dubbel benoemd'}}</span>
            </div>

        </div>

    </div>
</div>